import React from 'react';
import { motion } from 'framer-motion';
import { Globe2, Award, Users, TrendingUp } from 'lucide-react';
import { fadeInUp, staggerContainer } from '../lib/animations';
const features = [{
  icon: <Award className="w-8 h-8" data-id="element-147" />,
  title: 'Unmatched Quality',
  description: 'Rigorous 4-point quality control system ensuring zero-defect fabrics for every shipment.'
}, {
  icon: <Globe2 className="w-8 h-8" data-id="element-148" />,
  title: 'Global Reach',
  description: 'Seamless export capabilities with handled documentation for over 12 countries.'
}, {
  icon: <Users className="w-8 h-8" data-id="element-149" />,
  title: 'Client Partnership',
  description: 'We work as your manufacturing partner, offering transparency and dedicated support.'
}, {
  icon: <TrendingUp className="w-8 h-8" data-id="element-150" />,
  title: 'Market Innovation',
  description: 'Constantly updating our weaves and designs to stay ahead of global fashion trends.'
}];
export function WhyChooseUs() {
  return <section id="why-us" className="py-24 md:py-32 bg-[#1e3a8a] relative overflow-hidden" data-id="element-151">
      {/* Abstract Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-152">
        <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-153">
          <path d="M0 100 C 20 0 50 0 100 100 Z" fill="white" data-id="element-154" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-155">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} className="text-center max-w-3xl mx-auto mb-20" data-id="element-156">
          <motion.h2 variants={fadeInUp} className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-157">
            Why Leading Brands Trust Us
          </motion.h2>
          <motion.p variants={fadeInUp} className="text-blue-100 text-lg leading-relaxed" data-id="element-158">
            We combine traditional craftsmanship with modern efficiency to
            deliver value that goes beyond just fabric.
          </motion.p>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-159">
          {features.map((feature, index) => <motion.div key={index} variants={fadeInUp} whileHover={{
          y: -10
        }} className="bg-white/5 backdrop-blur-lg border border-white/10 p-8 rounded-2xl hover:bg-white/10 transition-colors duration-300" data-id="element-160">
              <div className="bg-white/10 w-14 h-14 rounded-xl flex items-center justify-center mb-6 text-white shadow-inner" data-id="element-161">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-162">
                {feature.title}
              </h3>
              <p className="text-blue-100/80 leading-relaxed text-sm" data-id="element-163">
                {feature.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}